export enum LegalStatus {
  PRESCRIPTION = 'prescription',
  OTC = 'otc',
  NARCOTIC = 'narcotic',
  PARA_PHARMACEUTICAL = 'para_pharmaceutical',
  OTHER = 'other',
}
